/* eslint-disable  */

import { useContext, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import ajax from '../utils/ajaxHelper';
import { getCompanyId, getClientSignupDetailsId, waiverAndContractFilePath } from '../utils';
import { API_EVENTS, DISCOUNT } from '../constants/actionTypes';
import useAuth from './useAuth';
import { ClientSignupContext } from '../contexts/ClientSignupContext';
import useValidateSettings from './useValidateSettings';
import useUtilities from './useUtilities';
import moment from 'moment';

// import authReducer, { initialState } from '../../../reducers/loginReducer';
// import { AUTH_EVENTS } from '../../../constants/actionTypes';

const useClientSignup = () => {
  const [clientSignupState, clientSignupDispatch] = useContext(ClientSignupContext);
  const { updateSettings } = useValidateSettings();
  const { isSoloClient, isLoggedIn } = useUtilities();
  const { fetchCompanyId, requestCompanyId } = useAuth();

  const companyId = clientSignupState?.companyId || getCompanyId();
  const navigate = useNavigate();
  const { clientSignupId } = useParams();
  const isClientLogin = isSoloClient() && isLoggedIn();

  const clientSignupDetailsId =
    getClientSignupDetailsId() ||
    clientSignupState?.data?.clientAccountDetails?.clientSignupDetailsId;
  
  const userPassword = clientSignupState?.data?.clientAccountDetails?.password;
  const emailId = clientSignupState?.data?.clientAccountDetails?.emailId;
  // const clientSignupDetailsId =
  //   clientSignupId || clientSignupState?.data?.clientAccountDetails?.clientSignupDetailsId;

  const userId = clientSignupState?.data?.clientAccountDetails?.userId;

  const resetClientSignupState = useCallback(() => {
    clientSignupDispatch({ type: API_EVENTS.RESET });
  }, [clientSignupDispatch]);

  const getClientDetails = useCallback(
    async (company = true, clientId = '', profile = 0, userId = null) => {
      try {
        // const clientSignupId = clientId;
        if (company) {
          // let clientId = clientSignupId || clientSignupDetailsId;
          // alert(company+"="+clientId+"="+profile);
          const res = await ajax.post(
            'get-client-details',
            {
              companyId,
              clientSignupDetailsId: clientId || clientSignupDetailsId,
              clientProfile: profile,
              userId,
            },
            {
              networkParams: { showLoader: true },
            },
          );
          const sortByIds = (arr) => {
            return arr.reduce((acc, item) => {
              acc.push(item._id);
              return acc;
            }, []);
          };
          const payload = {
            purchaseDetails: [],
            clientAccountDetails: {
              ...res?.data?.clientAccountDetails,
              clientSignupDetailsId: res?.data?.clientSignupDetailsId,
              dob: res?.data?.userId?.dob,
              gender: res?.data?.userId?.gender || '3',
              stateName: res?.data?.clientAccountDetails?.state?.name || '',
              state: res?.data?.clientAccountDetails?.state?._id || '',
              password: '',
              confirmPassword: '',
              contactId: res?.data?.clientAccountDetails?._id,
              userId: res?.data?.userId?._id,
              raceEthnicity: res?.data?.userId?.raceEthnicity,
              visitDates: res?.data?.classVisit,
              emergencyContact: {
                firstName: res?.data?.emergencyContact?.firstName,
                lastName: res?.data?.emergencyContact?.lastName,
                emailId: res?.data?.emergencyContact?.emailId,
                phone: res?.data?.emergencyContact?.phone,
                relationShip: res?.data?.emergencyContact?.relationShip,
                _id: res?.data?.emergencyContact?._id,
              },
              revenue: {
                year: res?.data?.revenue?.year || 0,
                overall: res?.data?.revenue?.overall || 0,
              },
              userDocument: {
                wavier: waiverAndContractFilePath(
                  res?.data?.wavierDoc?.path,
                  res?.data?.waiver?.signedWaiverPath,
                  res?.data?.signedWaiverDate,
                ),
                contract: waiverAndContractFilePath(
                  res?.data?.contractDoc?.path,
                  res?.data?.contract?.signedContractPath,
                  res?.data?.signedContractDate,
                ),
              },
              receiveEmails: res.data?.accountSettings?.firstInteraction
                ? res.data?.accountSettings?.receiveEmails
                : '1',
              firstInteraction: res?.data?.accountSettings?.firstInteraction || false,
              isAgeRequirementConfirmed: res?.data?.accountSettings?.isAgeRequirementConfirmed || false,
            },
            classPack: res?.data?.classPack,
            membership: res?.data?.membership,
            orderTotal: 0,
            waiver: {
              ...res?.data?.waiver,
              terms: res?.data?.waiver?.terms ? sortByIds(res?.data?.waiver?.terms) : [],
              isSignatureTermsAgreed: res?.data?.waiver?.isSignatureTermsAgreed || '0',
              clientFullName: res?.data?.waiver?.clientFullName || '',
              signedWaiverPath: !(res?.data?.wavierDoc?.waiverUpdatedOn && res?.data?.signedWaiverDate && moment(res?.data?.wavierDoc?.waiverUpdatedOn).isAfter(moment.unix(res?.data?.signedWaiverDate))) ? res?.data?.waiver?.signedWaiverPath : null,
            },

            cardholderDetails: res?.data?.cardholderDetails
              ? {
                  ...res?.data?.cardholderDetails,
                  stateName: res?.data?.cardholderDetails?.state?.name || '',
                  state: res?.data?.cardholderDetails?.state?._id || '',
                  // expiryDate: '',
                  securityCode: '',
                }
              : null,
            contract: {
              ...res?.data?.contract,
              contractTerms: res?.data?.contract?.contractTerms
                ? sortByIds(res?.data?.contract?.contractTerms)
                : [],
              isContractSignatureTermsAgreed:
                res?.data?.contract?.isContractSignatureTermsAgreed || '0',
              clientContractFullName: res?.data?.contract?.clientContractFullName || '',
              signedContractPath: !(res?.data?.contractDoc?.contractUpdatedOn && res?.data?.signedContractDate && moment(res?.data?.contractDoc?.contractUpdatedOn).isAfter(moment.unix(res?.data?.signedContractDate))) ? res?.data?.contract?.signedContractPath : null,
            },
            contractStatus: {
              contractUpdated: res?.data?.contractDoc?.contractUpdatedOn && res?.data?.signedContractDate ? moment(res?.data?.contractDoc?.contractUpdatedOn).isAfter(moment.unix(res?.data?.signedContractDate)): false,
              waiverUpdated: res?.data?.wavierDoc?.waiverUpdatedOn && res?.data?.signedWaiverDate ? moment(res?.data?.wavierDoc?.waiverUpdatedOn).isAfter(moment.unix(res?.data?.signedWaiverDate)): false,
            }
          };
          clientSignupDispatch({
            type: API_EVENTS.SUCCESS,
            payload,
          });
          
          return payload;
        } else {
          clientSignupDispatch({
            type: API_EVENTS.FAIL,
            payload: new Error('Company is not available'),
          });
        }
      } catch (error) {
        navigate('../../');
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      }
    },
    [clientSignupDispatch, clientSignupDetailsId, companyId, navigate],
  );

  const requestCompany = useCallback(async () => {
    const company = await requestCompanyId();
    if (clientSignupId) {
      getClientDetails(company);
    }
    clientSignupDispatch({ type: 'COMPANY_ID', payload: company });
  }, [requestCompanyId, clientSignupId, clientSignupDispatch, getClientDetails]);

  const createClientAccount = useCallback(
    async (values, { resetForm, setStatus, setSubmitting }, handleNxt, page = '') => {
      const { redirectPath, ...data } = values;
      delete data.isStaffEmailIdExists;
      clientSignupDispatch({ type: API_EVENTS.REQUEST });
      const companyIdTemp = await fetchCompanyId();
      try {
        const res = await ajax.post(
          'create-client-account',
          {
            ...data,
            //  gender: data?.gender === '3' ? null : data?.gender,
            companyId: companyId || companyIdTemp,
          },
          {
            networkParams: { showLoader: false },
          },
        );

        resetForm();
        setStatus({ success: true });
        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            // handleNext: !isClientLogin,
            clientAccountDetails: {
              ...data,
              stateName: res?.stateName || '',
              emergencyContact: {
                ...data?.emergencyContact,
                _id: res.emergencyContactId,
              },
              clientSignupDetailsId: res.clientSignupDetailsId,
              userId: res.userId,
              contactId: res.contactId,
            },
          },
        });

        if (redirectPath && isClientLogin) {
          updateSettings(redirectPath);
          navigate(redirectPath);
        }
        // if(page == "profile"){
        handleNxt();
        // }
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      } finally {
        setSubmitting(false);
      }
    },
    [clientSignupDispatch, companyId, updateSettings, navigate, isClientLogin],
  );

  const createNotifications = useCallback(
    async (values, { resetForm, setStatus, setSubmitting }, handleNxt) => {
      const { redirectPath, ...data } = values;

      try {
        clientSignupDispatch({ type: API_EVENTS.REQUEST });
        const res = await ajax.post(
          'create-client-account-settings',
          {
            ...data,
            clientSignupDetailsId,
            companyId,
          },
          { networkParams: { showLoader: true } },
        );

        const userCookie = Cookies.get('user');
        if (res && !userCookie) {
          await ajax.post(
            'client-confirmation',
            {
              companyId,
              clientSignupDetailsId,
              userPassword,
              emailId,
              discountAmt: data.discountAmt,
              amount: data?.amount || 0,
              classId: sessionStorage.getItem('classInstanceId') || '',
            },
            { networkParams: { showLoader: true } },
          );
        }
        if (!isClientLogin) {
          handleNxt();
        }
        resetForm();
        // resetClientSignupState();
        setStatus({ success: true });
        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            handleNext: !isClientLogin,
            accountSettings: { ...data },
          },
        });
        if (redirectPath && isClientLogin) {
          updateSettings(redirectPath);
          navigate(redirectPath);
        }
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      } finally {
        setSubmitting(false);
      }
    },
    [
      navigate,
      clientSignupDispatch,
      clientSignupDetailsId,
      companyId,
      updateSettings,
      isClientLogin,
      userPassword,
      emailId,
      // resetClientSignupState,
    ],
  );

  const createClientPackage = useCallback(
    async (values, handleNxt) => {
      const {
        redirectPath,
        data: { classPack, membership },
        updateSettingsFlag = true,
      } = values;

      const classPackId = classPack.reduce((acc, item) => {
        acc.push(item._id);
        return acc;
      }, []);

      const membershipId = membership.reduce((acc, item) => {
        acc.push(item._id);
        return acc;
      }, []);
      try {
        clientSignupDispatch({ type: API_EVENTS.REQUEST });
        await ajax.post(
          'create-client-package',
          {
            classPack: classPackId,
            membership: membershipId,
            clientSignupDetailsId,
            companyId,
          },
          { networkParams: { showLoader: true } },
        );
        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            handleNext: !isClientLogin,
            classPack,
            membership,
          },
        });

        if (redirectPath && isClientLogin) {
          if (updateSettingsFlag) updateSettings(redirectPath);
          navigate(redirectPath);
        }
        if (!isClientLogin) {
          handleNxt();
        }
      } catch (error) {
        console.log('error-client-package', error);
        // clientSignupDispatch({ type: API_EVENTS.FAIL, payload: error });
      }
    },
    [
      navigate,
      clientSignupDispatch,
      clientSignupDetailsId,
      companyId,
      updateSettings,
      isClientLogin,
    ],
  );

  const checkEmailId = useCallback(
    async (data, callback) => {
      try {
        const companyIdTemp = await fetchCompanyId();
        if (companyId || companyIdTemp) {
          const res = await ajax.post(
            'validate-client-email',
            {
              companyId: companyId || companyIdTemp,
              ...data,
            },
            {
              networkParams: { showLoader: false },
            },
          );

          callback(res?.isStaffEmailIdExists);
        } else {
          clientSignupDispatch({
            type: API_EVENTS.FAIL,
            payload: new Error('Company is not available'),
          });
          callback(false);
        }
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      }
    },
    [clientSignupDispatch, companyId],
  );

  const createWaiver = useCallback(
    async (values, { resetForm, setStatus, setSubmitting }, handleNxt, forceHandleNext) => {
      const { redirectPath, ...data } = values;

      try {
        clientSignupDispatch({ type: API_EVENTS.REQUEST });
        await ajax.post(
          'create-client-waiver-settings',
          {
            ...data,
            clientSignupDetailsId,
            companyId,
          },
          { networkParams: { showLoader: true } },
        );
        resetForm();
        setStatus({ success: true });
        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            handleNext: !isClientLogin,
            waiver: {
              ...data,
            },
          },
        });
        if(forceHandleNext) {
          handleNxt();
        }
        if (redirectPath && isClientLogin && !forceHandleNext) {
          updateSettings(redirectPath);
          navigate(redirectPath);
        }
        if (!isClientLogin) {
          handleNxt();
        }
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      } finally {
        setSubmitting(false);
      }
    },
    [
      navigate,
      clientSignupDispatch,
      clientSignupDetailsId,
      companyId,
      updateSettings,
      isClientLogin,
    ],
  );

  const createTerms = useCallback(
    async (values, { resetForm, setStatus, setSubmitting }, handleNxt, forceHandleNext = false) => {
      const { redirectPath, ...data } = values;
      try {
        clientSignupDispatch({ type: API_EVENTS.REQUEST });
        await ajax.post(
          'create-client-contract-terms',
          {
            ...data,
            clientSignupDetailsId,
            companyId,
          },
          { networkParams: { showLoader: true } },
        );
        resetForm();
        setStatus({ success: true });
        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            handleNext: !isClientLogin,
            contract: {
              ...data,
            },
          },
        });
        if(forceHandleNext) {
          handleNxt();
        }
        if (redirectPath && isClientLogin && !forceHandleNext) {
          updateSettings(redirectPath);
          navigate(redirectPath);
        }
        if (!isClientLogin) {
          handleNxt();
        }
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      } finally {
        setSubmitting(false);
      }
    },
    [
      navigate,
      clientSignupDispatch,
      clientSignupDetailsId,
      companyId,
      updateSettings,
      isClientLogin,
    ],
  );

  const makePayment = useCallback(
    async (values, { setErrors, resetForm, setStatus, setSubmitting }, callback, handleNxt) => {
      const { redirectPath, updateSettingsFlag = true, ...data } = values;

      delete data.hasMembership;
      try {
        clientSignupDispatch({ type: API_EVENTS.REQUEST });
        await ajax.post(
          'make-client-payment',
          {
            ...data,
            clientSignupDetailsId,
            userId,
            userPassword,
            companyId,
          },
          {
            networkParams: {
              showLoader: true,
              loaderTxt: 'Contacting your payment provider...',
            },
          },
        );
        resetForm();
        // resetClientSignupState();
        setStatus({ success: true });

        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            handleNext: !isClientLogin,
            cardholderDetails: { ...data },
          },
        });
        callback();
        if (redirectPath && isClientLogin) {
          if (updateSettingsFlag) updateSettings(redirectPath);
          if (!updateSettingsFlag) navigate(redirectPath);
        }
        if (!isClientLogin) {
          handleNxt();
        }
      } catch (error) {
        setTimeout(() => {
          setStatus({ success: false });
          // eslint-disable-next-line prefer-template
          setErrors({ submit: error.message + ' ' + error.reason });
          clientSignupDispatch({
            type: API_EVENTS.FAIL,
            payload: error,
          });
          callback({error: true});
        }, 2000);
      } finally {
        resetForm();
        setSubmitting(false);
      }
    },
    [
      navigate,
      clientSignupDispatch,
      clientSignupDetailsId,
      companyId,
      userId,
      updateSettings,
      isClientLogin,
      // resetClientSignupState,
      userPassword,
    ],
  );

  const freePackagePurchase = useCallback(
    async (values, callback) => {
      const { redirectPath, updateSettingsFlag = true, ...data } = values;

      delete data.hasMembership;
      try {
        clientSignupDispatch({ type: API_EVENTS.REQUEST });
        await ajax.post(
          'free-package-purchase-details',
          {
            ...data,
            clientSignupDetailsId,
            userId,
          },
          {
            networkParams: {
              showLoader: true,
              loaderTxt: 'Contacting your payment provider...',
            },
          },
        );

        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: { handleNext: !isClientLogin },
        });
        callback();
        if (redirectPath && isClientLogin) {
          if (updateSettingsFlag) updateSettings(redirectPath);
          if (redirectPath) navigate(redirectPath);
        }
      } catch (error) {
        setTimeout(() => {
          clientSignupDispatch({
            type: API_EVENTS.FAIL,
            payload: error,
          });
        }, 2000);
      }
    },
    [navigate, clientSignupDispatch, clientSignupDetailsId, userId, updateSettings, isClientLogin],
  );

  const getPurchasedPackageDetailsForUser = useCallback(
    async (callback) => {
      try {
        const data = await ajax.post('get-purchased-package-list-for-user', {
          userId,
        });

        callback(data?.data);
      } catch (error) {
        console.log(error);
      }
    },
    [userId],
  );

  const validatePromoCode = useCallback(
    async (data, callback) => {
      try {
        if (companyId) {
          const res = await ajax.post(
            'validate-client-promocode',
            { companyId, ...data, clientSignupDetailsId },
            {
              networkParams: { showLoader: false },
            },
          );

          return callback(res.isValid ? res.data : null, null);
        } else {
          callback(null, new Error('Invalid Promo Code'));
        }
      } catch (error) {
        return callback(null, error);
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      }
    },
    [clientSignupDispatch, companyId],
  );

  const calculateDiscount = useCallback(
    async (data) => {
      clientSignupDispatch({ type: DISCOUNT.SUCCESS, payload: data });
    },
    [clientSignupDispatch],
  );

  const updateClientCardDetails = useCallback(
    async (values, { resetForm, setStatus, setSubmitting }, handleNxt) => {
      clientSignupDispatch({ type: API_EVENTS.REQUEST });
      try {
        setSubmitting(true);
        const res = await ajax.post(
          'update-client-card-details',
          {
            ...values,
          },
          {
            networkParams: { showLoader: false },
          },
        );

        resetForm();
        setStatus({ success: true });
        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            ...clientSignupState?.data,
            cardholderDetails: {
              ...res?.data,
              stateName: res?.data?.state?.name || '',
              state: res?.data?.state?._id || '',
            },
          },
        });
        setSubmitting(false);

        handleNxt();
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      } finally {
        setSubmitting(false);
      }
    },
    [clientSignupDispatch],
  );

  /* @Added by Vanita Khamkar @Date 2021-12-10 @Desc - get client purchase details */
  const getClientPurchases = useCallback(
    async (values, callback) => {
      clientSignupDispatch({ type: API_EVENTS.REQUEST });
      try {
        const res = await ajax.post(
          'get-client-purchase-details',
          {
            ...values,
          },
          {
            networkParams: { showLoader: false },
          },
        );

        callback(true, res?.data);
      } catch (error) {
        callback(false, null);
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      }
    },
    [clientSignupDispatch],
  );

  /* @Added by Faisal Khan @Date 2021-12-15 @Desc - getClientHistory */
  const getClientHistory = useCallback(
    async (data) => {
      clientSignupDispatch({ type: API_EVENTS.REQUEST });
      try {
        const res = await ajax.post('get-client-history', data, {
          networkParams: { showLoader: false },
        });
        let responseData = res?.data;
        if (res?.data) {
          responseData = res?.data.filter((history) => history.classInstance);
        }
        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            ...clientSignupState?.data,
            clientHistory: responseData,
          },
        });
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      }
    },
    [clientSignupDispatch],
  );

  const cancelPackage = useCallback(
    async (values, handleNxt) => {
      clientSignupDispatch({ type: API_EVENTS.REQUEST });
      try {
        const res = await ajax.post(
          'cancel-client-package',
          {
            ...values,
          },
          {
            networkParams: { showLoader: false },
          },
        );

        handleNxt();
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      }
    },
    [clientSignupDispatch],
  );

  const freezeClientPackageRequest = useCallback(
    async (values, handleNxt) => {
      clientSignupDispatch({ type: API_EVENTS.REQUEST });
      try {
        const res = await ajax.post(
          'freeze-client-package',
          {
            ...values,
            companyId,
          },
          {
            networkParams: { showLoader: false },
          },
        );
        return res?.status;
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
        return false;
      }
    },
    [clientSignupDispatch, companyId],
  );

  const cancelFreeze = useCallback(
    async (values) => {
      clientSignupDispatch({ type: API_EVENTS.REQUEST });
      try {
        const res = await ajax.post('cancel-freeze', values, {
          networkParams: { showLoader: false },
        });
        return res?.status;
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
        return false;
      }
    },
    [clientSignupDispatch],
  );

  /* @Added by Faisal Khan @Date 2021-12-15 @Desc - getClientHistory */
  const getFreezeClientPackageList = useCallback(
    async (data) => {
      clientSignupDispatch({ type: API_EVENTS.REQUEST });
      try {
        const res = await ajax.post('freeze-client-package-list', data, {
          //const res = await ajax.post('freezed-client-package-list', data, {
          networkParams: { showLoader: false },
        });

        clientSignupDispatch({
          type: API_EVENTS.SUCCESS,
          payload: {
            ...clientSignupState?.data,
            freezeClientPackageList: res?.data,
          },
        });
      } catch (error) {
        clientSignupDispatch({
          type: API_EVENTS.FAIL,
          payload: error,
        });
      }
    },
    [clientSignupDispatch],
  );

  return {
    requestCompany,
    getClientDetails,
    createClientAccount,
    createNotifications,
    createClientPackage,
    makePayment,
    createWaiver,
    createTerms,
    checkEmailId,
    clientSignupState,
    getPurchasedPackageDetailsForUser,
    freePackagePurchase,
    resetClientSignupState,
    validatePromoCode,
    calculateDiscount,
    updateClientCardDetails,
    getClientPurchases,
    cancelPackage,
    getClientHistory,
    freezeClientPackageRequest,
    getFreezeClientPackageList,
    cancelFreeze,
  };
};

export default useClientSignup;
